import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { format } from 'date-fns';
import { Department } from 'server/shared/models/department';
import { EmploymentAvailabilityStatusEnum } from 'server/shared/models/user';
import { dbDayDateToken } from 'server/static/dbDayDateToken';
import { PermissionsService } from '../../../services/permissions.service';
import { EmploymentAvailabilityManagementService } from '../../availability-management/service/employment-availability-management.service';

export type CreateEmploymentDialogData = {
  personName: string;
  departmentId?: string;
  startDate?: string;
  endDate?: string;
  workload?: number;
};
@Component({
  selector: 'temp-work-edit-availability-dialog',
  templateUrl: 'create-employment-dialog.html',
  styleUrls: ['create-employment-dialog.scss'],
  providers: [EmploymentAvailabilityManagementService],
})
export class CreateEmploymentDialogComponent {
  preparedFromDate?: string;
  constructor(
    public dialogRef: MatDialogRef<CreateEmploymentDialogComponent>,
    public permissionsService: PermissionsService,
    @Inject(MAT_DIALOG_DATA)
    public data: CreateEmploymentDialogData,
    public managementService: EmploymentAvailabilityManagementService,
    private router: Router,
  ) {}

  updateStartDate(startDate: Date) {
    this.data.startDate = format(startDate, dbDayDateToken);
  }

  updateEndDate(endDate?: Date) {
    if (!endDate) {
      this.data.endDate = undefined;
      return;
    }
    this.data.endDate = format(endDate, dbDayDateToken);
  }

  updateQueryParams(queryParams: { [key: string]: string | null }) {
    this.router
      .navigate([], {
        queryParamsHandling: 'merge',
        queryParams,
      })
      .then();
  }

  clearDates() {
    this.updateQueryParams({
      selectedFrom: null,
      selectedTo: null,
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  readonly employmentAvailabilityStatusEnum = EmploymentAvailabilityStatusEnum;

  updateDepartment($event: Department | undefined) {
    this.data.departmentId = $event?.id;
  }
}
